import type { ParamValue } from "./types";

export function synthesiseUrl(
	url: string,
	params: Record<string, ParamValue>,
): [url: string, dynamicParams: string[]] {
	const urlParts = url.split("/");
	const dynamicParams: string[] = [];
	const output: string[] = [];

	for (const part of urlParts) {
		if (part.startsWith(":")) {
			const paramName = part.slice(1);
			const paramValue = params[paramName];

			if (!paramValue) {
				throw new Error(`Missing required parameter: ${paramName}`);
			}

			dynamicParams.push(paramName);

			if (typeof paramValue !== "object") {
				output.push(paramValue.toString());
			}
			// NOTE: (bwilytsch): Check what to do when object
		} else {
			output.push(part);
		}
	}
	return [output.join("/"), dynamicParams];
}
